// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {
  AppBar,
  Box,
  Button,
  Drawer,
  IconButton,
  Toolbar,
  Typography
} from '@material-ui/core';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Menu as MenuIcon} from '@material-ui/icons';
import PatientDetailsSideBar from '../PatientDetailsSidebar/PatientDetailsSidebar';
import './PatientDetailsTopBar.scss';
import {CommunicationService} from 'src/service/CommunicationService';

interface PatientDetailsTopBarProps {
  closeDrawer: () => void;
}
const PatientDetailsTopBar = (
  props: PatientDetailsTopBarProps
): React.ReactElement => {
  const {closeDrawer} = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  // FIXME: ADD PROPER TYPES
  const selectedPatient = useSelector(
    (state: any) => state.patientDetailsDrawer.patientDetails
  );
  const consolidatedBillingGroupEnable: boolean = useSelector(
    (state: any) => state.clinics.consolidatedBillingGroupEnable
  );

  const selectedClinicLabel: any = useSelector(
    (state: any) => state.clinics.selectedClinicLabel
  );

  const selectedClinicId: number = useSelector(
    (state: any) => state.patientDetailsDrawer.clinicId
  );
  const clinics: any[] = useSelector((state: any) => state?.clinics?.list);
  const selectedClinic = clinics.find(clinic => clinic.id === selectedClinicId);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const {t} = useTranslation();

  const patientFullName = `${selectedPatient['first_name'] ?? ''} ${
    selectedPatient['middle_name'] ?? ''
  } ${selectedPatient['last_name'] ?? ''}`;

  const clinicLabel = selectedClinicLabel?.[0] ?? selectedClinic?.name ?? '';

  return (
    <AppBar position="sticky" className={'patient-details-top-bar'}>
      <Toolbar className={'tool-bar'}>
        <Box className={'left-wrapper'}>
          <Box className={'hamburger-wrapper'}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              className={['menu-button', 'icon-label'].join(' ')}>
              <MenuIcon />
            </IconButton>
            <Drawer
              className={'drawer-override'}
              anchor="left"
              open={mobileOpen}
              onClose={handleDrawerToggle}>
              <PatientDetailsSideBar
                onNavItemClick={handleDrawerToggle}
                closeDrawer={closeDrawer}
              />
            </Drawer>
          </Box>
          <Box className={'drawer-title'}>
            <Typography className="patient-full-name">
              {patientFullName}
            </Typography>
            {!consolidatedBillingGroupEnable && clinicLabel !== '' && (
              <Typography className="clinic-label">{`(${clinicLabel})`}</Typography>
            )}
          </Box>
        </Box>
        <Button
          data-test-id="pcl-appointments-closePatientsDetails"
          color="primary"
          variant="outlined"
          className={'close-button'}
          onClick={() => {
            closeDrawer();
            // Trigger an event in grid when patient details drawer is closed
            CommunicationService.sendEvent({
              action: 'CCM_PLAN_STATUS_UPDATED',
              data: null
            });
          }}>
          {t('COMMON.CLOSE')}
        </Button>
      </Toolbar>
    </AppBar>
  );
};
export default PatientDetailsTopBar;
